import type { FormField } from "@prequel/import-react";

/** Formats a field's value for display, or null when there is nothing to show. */
export const formatFieldValue = (field: FormField, value: unknown): string | null => {
  const displayed = field.behavior === "display" || field.behavior === "fixed" ? field.const : value;

  if (displayed === null || displayed === undefined || displayed === "") {
    return null;
  }
  if (typeof displayed === "boolean") {
    return displayed ? "Yes" : "No";
  }

  const option = field.enum?.find((entry) => String(entry.key) === String(displayed));
  if (option) {
    return option.display;
  }

  if (typeof displayed === "object") {
    return JSON.stringify(displayed, null, 2);
  }
  return String(displayed);
};
